require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.index-of");

/* UAParser.js v2.0.3
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   AGPLv3 License */
(function (i, l) {
  function U(i) {
    for (var e = {}, t = 0; t < i.length; t++) {
      e[i[t].toUpperCase()] = i[t];
    }

    return e;
  }

  var E = 500,
      P = "user-agent",
      w = "",
      B = "?",
      R = "function",
      n = "undefined",
      c = "object",
      V = "string",
      u = "browser",
      h = "cpu",
      p = "device",
      m = "engine",
      f = "os",
      g = "result",
      v = "name",
      k = "type",
      x = "vendor",
      y = "version",
      C = "architecture",
      L = "major",
      T = "model",
      G = "console",
      S = "mobile",
      r = "tablet",
      e = "smarttv",
      t = "wearable",
      F = "xr",
      D = "embedded",
      $ = "inapp",
      W = "brands",
      _ = "formFactors",
      X = "fullVersionList",
      q = "platform",
      Y = "platformVersion",
      K = "bitness",
      o = "sec-ch-ua",
      Q = o + "-full-version-list",
      Z = o + "-arch",
      J = o + "-" + K,
      ii = o + "-form-factors",
      ei = o + "-" + S,
      ti = o + "-" + T,
      oi = o + "-" + q,
      ri = oi + "-version",
      ai = [W, X, S, T, q, Y, C, _, K],
      si = "Amazon",
      a = "Apple",
      ni = "ASUS",
      wi = "BlackBerry",
      s = "Google",
      bi = "Huawei",
      di = "Microsoft",
      li = "Motorola",
      ci = "Nvidia",
      ui = "OnePlus",
      hi = "OPPO",
      pi = "Samsung",
      mi = "Sony",
      fi = "Xiaomi",
      gi = "Zebra",
      vi = "Chromium",
      b = "Chromecast",
      ki = "Firefox",
      d = "Opera",
      xi = "Facebook",
      A = "Mobile ",
      yi = " Browser",
      Ci = "Windows",
      Ti = typeof i !== n,
      z = Ti && i.navigator ? i.navigator : l,
      O = z && z.userAgentData ? z.userAgentData : l,
      Si = function Si(i, e) {
    if (typeof i === c && 0 < i.length) {
      for (var t in i) {
        if (M(i[t]) == M(e)) return !0;
      }

      return !1;
    }

    return !!H(i) && -1 !== M(e).indexOf(M(i));
  },
      _i = function _i(i, e) {
    for (var t in i) {
      return /^(browser|cpu|device|engine|os)$/.test(t) || !!e && _i(i[t]);
    }
  },
      H = function H(i) {
    return typeof i === V;
  },
      qi = function qi(i) {
    if (!i) return l;

    for (var e, t = [], o = zi(/\\?\"/g, i).split(","), r = 0; r < o.length; r++) {
      -1 < o[r].indexOf(";") ? (e = Hi(o[r]).split(";v="), t[r] = {
        brand: e[0],
        version: e[1]
      }) : t[r] = Hi(o[r]);
    }

    return t;
  },
      M = function M(i) {
    return H(i) ? i.toLowerCase() : i;
  },
      Ai = function Ai(i) {
    return H(i) ? zi(/[^\d\.]/g, i).split(".")[0] : l;
  },
      j = function j(i) {
    for (var e in i) {
      e = i[e];
      typeof e == c && 2 == e.length ? this[e[0]] = e[1] : this[e] = l;
    }

    return this;
  },
      zi = function zi(i, e) {
    return H(e) ? e.replace(i, w) : e;
  },
      Oi = function Oi(i) {
    return zi(/\\?\"/g, i);
  },
      Hi = function Hi(i, e) {
    if (H(i)) return i = zi(/^\s\s*/, i), typeof e === n ? i : i.substring(0, E);
  },
      Mi = function Mi(i, e) {
    if (i && e) for (var t, o, r, a, s, n = 0; n < e.length && !a;) {
      for (var w = e[n], b = e[n + 1], d = t = 0; d < w.length && !a && w[d];) {
        if (a = w[d++].exec(i)) for (o = 0; o < b.length; o++) {
          s = a[++t], typeof (r = b[o]) === c && 0 < r.length ? 2 === r.length ? typeof r[1] == R ? this[r[0]] = r[1].call(this, s) : this[r[0]] = r[1] : 3 === r.length ? typeof r[1] !== R || r[1].exec && r[1].test ? this[r[0]] = s ? s.replace(r[1], r[2]) : l : this[r[0]] = s ? r[1].call(this, s, r[2]) : l : 4 === r.length && (this[r[0]] = s ? r[3].call(this, s.replace(r[1], r[2])) : l) : this[r] = s || l;
        }
      }

      n += 2;
    }
  },
      N = function N(i, e) {
    for (var t in e) {
      if (typeof e[t] === c && 0 < e[t].length) {
        for (var o = 0; o < e[t].length; o++) {
          if (Si(e[t][o], i)) return t === B ? l : t;
        }
      } else if (Si(e[t], i)) return t === B ? l : t;
    }

    return e.hasOwnProperty("*") ? e["*"] : i;
  },
      ji = {
    ME: "4.90",
    "NT 3.11": "NT3.51",
    "NT 4.0": "NT4.0",
    2e3: "NT 5.0",
    XP: ["NT 5.1", "NT 5.2"],
    Vista: "NT 6.0",
    7: "NT 6.1",
    8: "NT 6.2",
    8.1: "NT 6.3",
    10: ["NT 6.4", "NT 10.0"],
    RT: "ARM"
  },
      Ni = {
    embedded: "Automotive",
    mobile: "Mobile",
    tablet: ["Tablet", "EInk"],
    smarttv: "TV",
    wearable: "Watch",
    xr: ["VR", "XR"],
    "?": ["Desktop", "Unknown"],
    "*": l
  },
      Ii = {
    browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [y, [v, A + "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [y, [v, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [v, y], [/opios[\/ ]+([\w\.]+)/i], [y, [v, d + " Mini"]], [/\bop(?:rg)?x\/([\w\.]+)/i], [y, [v, d + " GX"]], [/\bopr\/([\w\.]+)/i], [y, [v, d]], [/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i], [y, [v, "Baidu"]], [/\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i], [y, [v, "Maxthon"]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i, /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon|otter|dooble|(?:lg |qute)browser)\/([-\w\.]+)/i, /(heytap|ovi|115|surf)browser\/([\d\.]+)/i, /(ecosia|weibo)(?:__| \w+@)([\d\.]+)/i], [v, y], [/quark(?:pc)?\/([-\w\.]+)/i], [y, [v, "Quark"]], [/\bddg\/([\w\.]+)/i], [y, [v, "DuckDuckGo"]], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [y, [v, "UCBrowser"]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i, /micromessenger\/([\w\.]+)/i], [y, [v, "WeChat"]], [/konqueror\/([\w\.]+)/i], [y, [v, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [y, [v, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i], [y, [v, "Yandex"]], [/slbrowser\/([\w\.]+)/i], [y, [v, "Smart Lenovo" + yi]], [/(avast|avg)\/([\w\.]+)/i], [[v, /(.+)/, "$1 Secure" + yi], y], [/\bfocus\/([\w\.]+)/i], [y, [v, ki + " Focus"]], [/\bopt\/([\w\.]+)/i], [y, [v, d + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [y, [v, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [y, [v, "Dolphin"]], [/coast\/([\w\.]+)/i], [y, [v, d + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [y, [v, "MIUI" + yi]], [/fxios\/([\w\.-]+)/i], [y, [v, A + ki]], [/\bqihoobrowser\/?([\w\.]*)/i], [y, [v, "360"]], [/\b(qq)\/([\w\.]+)/i], [[v, /(.+)/, "$1Browser"], y], [/(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i], [[v, /(.+)/, "$1" + yi], y], [/samsungbrowser\/([\w\.]+)/i], [y, [v, pi + " Internet"]], [/metasr[\/ ]?([\d\.]+)/i], [y, [v, "Sogou Explorer"]], [/(sogou)mo\w+\/([\d\.]+)/i], [[v, "Sogou Mobile"], y], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i], [v, y], [/(lbbrowser|rekonq)/i], [v], [/ome\/([\w\.]+) \w* ?(iron) saf/i, /ome\/([\w\.]+).+qihu (360)[es]e/i], [y, v], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[v, xi], y, [k, $]], [/(Klarna)\/([\w\.]+)/i, /(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /(daum)apps[\/ ]([\w\.]+)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(alipay)client\/([\w\.]+)/i, /(twitter)(?:and| f.+e\/([\w\.]+))/i, /(instagram|snapchat)[\/ ]([-\w\.]+)/i], [v, y, [k, $]], [/\bgsa\/([\w\.]+) .*safari\//i], [y, [v, "GSA"], [k, $]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i], [y, [v, "TikTok"], [k, $]], [/\[(linkedin)app\]/i], [v, [k, $]], [/(chromium)[\/ ]([-\w\.]+)/i], [v, y], [/headlesschrome(?:\/([\w\.]+)| )/i], [y, [v, "Chrome Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[v, "Chrome WebView"], y], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [y, [v, "Android" + yi]], [/chrome\/([\w\.]+) mobile/i], [y, [v, A + "Chrome"]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [v, y], [/version\/([\w\.\,]+) .*mobile(?:\/\w+ | ?)safari/i], [y, [v, A + "Safari"]], [/iphone .*mobile(?:\/\w+ | ?)safari/i], [[v, A + "Safari"]], [/version\/([\w\.\,]+) .*(safari)/i], [y, v], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [v, [y, "1"]], [/(webkit|khtml)\/([\w\.]+)/i], [v, y], [/(?:mobile|tablet);.*(firefox)\/([\w\.-]+)/i], [[v, A + ki], y], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[v, "Netscape"], y], [/(wolvic|librewolf)\/([\w\.]+)/i], [v, y], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [y, [v, ki + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /\b(links) \(([\w\.]+)/i], [v, [y, /_/g, "."]], [/(cobalt)\/([\w\.]+)/i], [v, [y, /[^\d\.]+./, w]]],
    cpu: [[/\b((amd|x|x86[-_]?|wow|win)64)\b/i], [[C, "amd64"]], [/(ia32(?=;))/i, /\b((i[346]|x)86)(pc)?\b/i], [[C, "ia32"]], [/\b(aarch64|arm(v?[89]e?l?|_?64))\b/i], [[C, "arm64"]], [/\b(arm(v[67])?ht?n?[fl]p?)\b/i], [[C, "armhf"]], [/( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i], [[C, "arm"]], [/((ppc|powerpc)(64)?)( mac|;|\))/i], [[C, /ower/, w, M]], [/ sun4\w[;\)]/i], [[C, "sparc"]], [/\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i], [[C, M]]],
    device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [T, [x, pi], [k, r]], [/\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]((?!sm-[lr])[-\w]+)/i, /sec-(sgh\w+)/i], [T, [x, pi], [k, S]], [/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i], [T, [x, a], [k, S]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [T, [x, a], [k, r]], [/(macintosh);/i], [T, [x, a]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [T, [x, "Sharp"], [k, S]], [/\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i], [T, [x, "Honor"], [k, r]], [/honor([-\w ]+)[;\)]/i], [T, [x, "Honor"], [k, S]], [/\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i], [T, [x, bi], [k, r]], [/(?:huawei)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [T, [x, bi], [k, S]], [/oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i, /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i], [[T, /_/g, " "], [x, fi], [k, r]], [/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i, / ([\w ]+) miui\/v?\d/i], [[T, /_/g, " "], [x, fi], [k, S]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [T, [x, hi], [k, S]], [/\b(opd2(\d{3}a?))(?: bui|\))/i], [T, [x, N, {
      OnePlus: ["304", "403", "203"],
      "*": hi
    }], [k, r]], [/(vivo (5r?|6|8l?|go|one|s|x[il]?[2-4]?)[\w\+ ]*)(?: bui|\))/i], [T, [x, "BLU"], [k, S]], [/; vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [T, [x, "Vivo"], [k, S]], [/\b(rmx[1-3]\d{3})(?: bui|;|\))/i], [T, [x, "Realme"], [k, S]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [T, [x, li], [k, S]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [T, [x, li], [k, r]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [T, [x, "LG"], [k, r]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+(?!.*(?:browser|netcast|android tv|watch))(\w+)/i, /\blg-?([\d\w]+) bui/i], [T, [x, "LG"], [k, S]], [/(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i, /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i], [T, [x, "Lenovo"], [k, r]], [/(nokia) (t[12][01])/i], [x, T, [k, r]], [/(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i, /nokia[-_ ]?(([-\w\. ]*))/i], [[T, /_/g, " "], [k, S], [x, "Nokia"]], [/(pixel (c|tablet))\b/i], [T, [x, s], [k, r]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [T, [x, s], [k, S]], [/droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [T, [x, mi], [k, S]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[T, "Xperia Tablet"], [x, mi], [k, r]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [T, [x, ui], [k, S]], [/(alexa)webm/i, /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [T, [x, si], [k, r]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[T, /(.+)/g, "Fire Phone $1"], [x, si], [k, S]], [/(playbook);[-\w\),; ]+(rim)/i], [T, x, [k, r]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [T, [x, wi], [k, S]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [T, [x, ni], [k, r]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [T, [x, ni], [k, S]], [/(nexus 9)/i], [T, [x, "HTC"], [k, r]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [x, [T, /_/g, " "], [k, S]], [/tcl (xess p17aa)/i, /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])(_\w(\w|\w\w))?(\)| bui)/i], [T, [x, "TCL"], [k, r]], [/droid [\w\.]+; (418(?:7d|8v)|5087z|5102l|61(?:02[dh]|25[adfh]|27[ai]|56[dh]|59k|65[ah])|a509dl|t(?:43(?:0w|1[adepqu])|50(?:6d|7[adju])|6(?:09dl|10k|12b|71[efho]|76[hjk])|7(?:66[ahju]|67[hw]|7[045][bh]|71[hk]|73o|76[ho]|79w|81[hks]?|82h|90[bhsy]|99b)|810[hs]))(_\w(\w|\w\w))?(\)| bui)/i], [T, [x, "TCL"], [k, S]], [/(itel) ((\w+))/i], [[x, M], T, [k, N, {
      tablet: ["p10001l", "w7001"],
      "*": "mobile"
    }]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [T, [x, "Acer"], [k, r]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [T, [x, "Meizu"], [k, S]], [/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i], [T, [x, "Ulefone"], [k, S]], [/; (energy ?\w+)(?: bui|\))/i, /; energizer ([\w ]+)(?: bui|\))/i], [T, [x, "Energizer"], [k, S]], [/; cat (b35);/i, /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i], [T, [x, "Cat"], [k, S]], [/((?:new )?andromax[\w- ]+)(?: bui|\))/i], [T, [x, "Smartfren"], [k, S]], [/droid.+; (a(?:015|06[35]|142p?))/i], [T, [x, "Nothing"], [k, S]], [/; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i, /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i], [T, [x, "Archos"], [k, r]], [/archos ([\w ]+)( b|\))/i, /; (ac[3-6]\d\w{2,8})( b|\))/i], [T, [x, "Archos"], [k, S]], [/(imo) (tab \w+)/i, /(infinix) (x1101b?)/i], [x, T, [k, r]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i, /; (blu|hmd|imo|tcl)[_ ]([\w\+ ]+?)(?: bui|\)|; r)/i, /(hp) ([\w ]+\w)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i, /(oppo) ?([\w ]+) bui/i], [x, T, [k, S]], [/(kobo)\s(ereader|touch)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i], [x, T, [k, r]], [/(surface duo)/i], [T, [x, di], [k, r]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [T, [x, "Fairphone"], [k, S]], [/((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i], [T, [x, ci], [k, r]], [/(sprint) (\w+)/i], [x, T, [k, S]], [/(kin\.[onetw]{3})/i], [[T, /\./g, " "], [x, di], [k, S]], [/droid.+; ([c6]+|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [T, [x, gi], [k, r]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [T, [x, gi], [k, S]], [/smart-tv.+(samsung)/i], [x, [k, e]], [/hbbtv.+maple;(\d+)/i], [[T, /^/, "SmartTV"], [x, pi], [k, e]], [/tcast.+(lg)e?. ([-\w]+)/i], [x, T, [k, e]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[x, "LG"], [k, e]], [/(apple) ?tv/i], [x, [T, a + " TV"], [k, e]], [/crkey.*devicetype\/chromecast/i], [[T, b + " Third Generation"], [x, s], [k, e]], [/crkey.*devicetype\/([^/]*)/i], [[T, /^/, "Chromecast "], [x, s], [k, e]], [/fuchsia.*crkey/i], [[T, b + " Nest Hub"], [x, s], [k, e]], [/crkey/i], [[T, b], [x, s], [k, e]], [/(portaltv)/i], [T, [x, xi], [k, e]], [/droid.+aft(\w+)( bui|\))/i], [T, [x, si], [k, e]], [/(shield \w+ tv)/i], [T, [x, ci], [k, e]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [T, [x, "Sharp"], [k, e]], [/(bravia[\w ]+)( bui|\))/i], [T, [x, mi], [k, e]], [/(mi(tv|box)-?\w+) bui/i], [T, [x, fi], [k, e]], [/Hbbtv.*(technisat) (.*);/i], [x, T, [k, e]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[x, Hi], [T, Hi], [k, e]], [/droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i], [T, [k, e]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[k, e]], [/(ouya)/i, /(nintendo) (\w+)/i], [x, T, [k, G]], [/droid.+; (shield)( bui|\))/i], [T, [x, ci], [k, G]], [/(playstation \w+)/i], [T, [x, mi], [k, G]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [T, [x, di], [k, G]], [/\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i], [T, [x, pi], [k, t]], [/((pebble))app/i, /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i], [x, T, [k, t]], [/(ow(?:19|20)?we?[1-3]{1,3})/i], [T, [x, hi], [k, t]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [T, [x, a], [k, t]], [/(opwwe\d{3})/i], [T, [x, ui], [k, t]], [/(moto 360)/i], [T, [x, li], [k, t]], [/(smartwatch 3)/i], [T, [x, mi], [k, t]], [/(g watch r)/i], [T, [x, "LG"], [k, t]], [/droid.+; (wt63?0{2,3})\)/i], [T, [x, gi], [k, t]], [/droid.+; (glass) \d/i], [T, [x, s], [k, F]], [/(pico) (4|neo3(?: link|pro)?)/i], [x, T, [k, F]], [/(quest( \d| pro)?s?).+vr/i], [T, [x, xi], [k, F]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [x, [k, D]], [/(aeobc)\b/i], [T, [x, si], [k, D]], [/(homepod).+mac os/i], [T, [x, a], [k, D]], [/windows iot/i], [[k, D]], [/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+?(mobile|vr|\d) safari/i], [T, [k, N, {
      mobile: "Mobile",
      xr: "VR",
      "*": r
    }]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[k, r]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[k, S]], [/droid .+?; ([\w\. -]+)( bui|\))/i], [T, [x, "Generic"]]],
    engine: [[/windows.+ edge\/([\w\.]+)/i], [y, [v, "EdgeHTML"]], [/(arkweb)\/([\w\.]+)/i], [v, y], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [y, [v, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i, /\b(libweb)/i], [v, y], [/ladybird\//i], [[v, "LibWeb"]], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [y, v]],
    os: [[/microsoft (windows) (vista|xp)/i], [v, y], [/(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i], [v, [y, N, ji]], [/windows nt 6\.2; (arm)/i, /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i, /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[y, N, ji], [v, Ci]], [/[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i, /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[y, /_/g, "."], [v, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[v, "macOS"], [y, /_/g, "."]], [/android ([\d\.]+).*crkey/i], [y, [v, b + " Android"]], [/fuchsia.*crkey\/([\d\.]+)/i], [y, [v, b + " Fuchsia"]], [/crkey\/([\d\.]+).*devicetype\/smartspeaker/i], [y, [v, b + " SmartSpeaker"]], [/linux.*crkey\/([\d\.]+)/i], [y, [v, b + " Linux"]], [/crkey\/([\d\.]+)/i], [y, [v, b]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [y, v], [/(ubuntu) ([\w\.]+) like android/i], [[v, /(.+)/, "$1 Touch"], y], [/(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/\.; ]?([\d\.]*)/i], [v, y], [/\(bb(10);/i], [y, [v, wi]], [/(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i], [y, [v, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [y, [v, ki + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [y, [v, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [y, [v, "watchOS"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[v, "Chrome OS"], y], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) (\w+)/i, /(xbox); +xbox ([^\);]+)/i, /(pico) .+os([\w\.]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [v, y], [/(sunos) ?([\w\.\d]*)/i], [[v, "Solaris"], y], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, /(unix) ?([\w\.]*)/i], [v, y]]
  },
      Ui = (d = {
    init: {},
    isIgnore: {},
    isIgnoreRgx: {},
    toString: {}
  }, j.call(d.init, [[u, [v, y, L, k]], [h, [C]], [p, [k, T, x]], [m, [v, y]], [f, [v, y]]]), j.call(d.isIgnore, [[u, [y, L]], [m, [y]], [f, [y]]]), j.call(d.isIgnoreRgx, [[u, / ?browser$/i], [f, / ?os$/i]]), j.call(d.toString, [[u, [v, y]], [h, [C]], [p, [x, T]], [m, [v, y]], [f, [v, y]]]), d),
      Ei = function Ei(e, i) {
    var t = Ui.init[i],
        o = Ui.isIgnore[i] || 0,
        r = Ui.isIgnoreRgx[i] || 0,
        a = Ui.toString[i] || 0;

    function s() {
      j.call(this, t);
    }

    return s.prototype.getItem = function () {
      return e;
    }, s.prototype.withClientHints = function () {
      return O ? O.getHighEntropyValues(ai).then(function (i) {
        return e.setCH(new Pi(i, !1)).parseCH().get();
      }) : e.parseCH().get();
    }, s.prototype.withFeatureCheck = function () {
      return e.detectFeature().get();
    }, i != g && (s.prototype.is = function (i) {
      var e,
          t = !1;

      for (e in this) {
        if (this.hasOwnProperty(e) && !Si(o, e) && M(r ? zi(r, this[e]) : this[e]) == M(r ? zi(r, i) : i)) {
          if (t = !0, i != n) break;
        } else if (i == n && t) {
          t = !t;
          break;
        }
      }

      return t;
    }, s.prototype.toString = function () {
      var i,
          e = w;

      for (i in a) {
        typeof this[a[i]] !== n && (e += (e ? " " : w) + this[a[i]]);
      }

      return e || n;
    }), O || (s.prototype.then = function (i) {
      function e() {
        for (var i in t) {
          t.hasOwnProperty(i) && (this[i] = t[i]);
        }
      }

      var t = this,
          o = (e.prototype = {
        is: s.prototype.is,
        toString: s.prototype.toString
      }, new e());
      return i(o), o;
    }), new s();
  };

  function Pi(i, e) {
    if (i = i || {}, j.call(this, ai), e) j.call(this, [[W, qi(i[o])], [X, qi(i[Q])], [S, /\?1/.test(i[ei])], [T, Oi(i[ti])], [q, Oi(i[oi])], [Y, Oi(i[ri])], [C, Oi(i[Z])], [_, qi(i[ii])], [K, Oi(i[J])]]);else for (var t in i) {
      this.hasOwnProperty(t) && typeof i[t] !== n && (this[t] = i[t]);
    }
  }

  function Bi(i, e, t, o) {
    return this.get = function (i) {
      return i ? this.data.hasOwnProperty(i) ? this.data[i] : l : this.data;
    }, this.set = function (i, e) {
      return this.data[i] = e, this;
    }, this.setCH = function (i) {
      return this.uaCH = i, this;
    }, this.detectFeature = function () {
      if (z && z.userAgent == this.ua) switch (this.itemType) {
        case u:
          z.brave && typeof z.brave.isBrave == R && this.set(v, "Brave");
          break;

        case p:
          !this.get(k) && O && O[S] && this.set(k, S), "Macintosh" == this.get(T) && z && typeof z.standalone !== n && z.maxTouchPoints && 2 < z.maxTouchPoints && this.set(T, "iPad").set(k, r);
          break;

        case f:
          !this.get(v) && O && O[q] && this.set(v, O[q]);
          break;

        case g:
          var e = this.data,
              i = function i(_i2) {
            return e[_i2].getItem().detectFeature().get();
          };

          this.set(u, i(u)).set(h, i(h)).set(p, i(p)).set(m, i(m)).set(f, i(f));
      }
      return this;
    }, this.parseUA = function () {
      return this.itemType != g && Mi.call(this.data, this.ua, this.rgxMap), this.itemType == u && this.set(L, Ai(this.get(y))), this;
    }, this.parseCH = function () {
      var i,
          e = this.uaCH,
          t = this.rgxMap;

      switch (this.itemType) {
        case u:
        case m:
          var o,
              r = e[X] || e[W];
          if (r) for (var a in r) {
            var s = r[a].brand || r[a],
                a = r[a].version;
            this.itemType != u || /not.a.brand/i.test(s) || o && (!/chrom/i.test(o) || s == vi) || (s = N(s, {
              Chrome: "Google Chrome",
              Edge: "Microsoft Edge",
              "Chrome WebView": "Android WebView",
              "Chrome Headless": "HeadlessChrome",
              "Huawei Browser": "HuaweiBrowser",
              "MIUI Browser": "Miui Browser",
              "Opera Mobi": "OperaMobile",
              Yandex: "YaBrowser"
            }), this.set(v, s).set(y, a).set(L, Ai(a)), o = s), this.itemType == m && s == vi && this.set(y, a);
          }
          break;

        case h:
          var n = e[C];
          n && ("64" == e[K] && (n += "64"), Mi.call(this.data, n + ";", t));
          break;

        case p:
          if (e[S] && this.set(k, S), e[T] && (this.set(T, e[T]), this.get(k) && this.get(x) || (Mi.call(n = {}, "droid 9; " + e[T] + ")", t), !this.get(k) && n.type && this.set(k, n.type), !this.get(x) && n.vendor && this.set(x, n.vendor))), e[_]) {
            if ("string" != typeof e[_]) for (var w = 0; !i && w < e[_].length;) {
              i = N(e[_][w++], Ni);
            } else i = N(e[_], Ni);
            this.set(k, i);
          }

          break;

        case f:
          var b,
              n = e[q];
          n && (b = e[Y], n == Ci && (b = 13 <= parseInt(Ai(b), 10) ? "11" : "10"), this.set(v, n).set(y, b)), this.get(v) == Ci && "Xbox" == e[T] && this.set(v, "Xbox").set(y, l);
          break;

        case g:
          var d = this.data,
              n = function n(i) {
            return d[i].getItem().setCH(e).parseCH().get();
          };

          this.set(u, n(u)).set(h, n(h)).set(p, n(p)).set(m, n(m)).set(f, n(f));
      }

      return this;
    }, j.call(this, [["itemType", i], ["ua", e], ["uaCH", o], ["rgxMap", t], ["data", Ei(this, i)]]), this;
  }

  function I(i, e, t) {
    var o, r, a, s, n;
    return typeof i === c ? (e = _i(i, !0) ? (typeof e === c && (t = e), i) : (t = i, l), i = l) : typeof i !== V || _i(e, !0) || (t = e, e = l), t && typeof t.append === R && (o = {}, t.forEach(function (i, e) {
      o[e] = i;
    }), t = o), this instanceof I ? (r = typeof i === V ? i : t && t[P] ? t[P] : z && z.userAgent ? z.userAgent : w, a = new Pi(t, !0), s = e ? function (i, e) {
      var t,
          o = {},
          r = e;
      if (!_i(e)) for (var a in r = {}, e) {
        for (var s in e[a]) {
          r[s] = e[a][s].concat(r[s] || []);
        }
      }

      for (t in i) {
        o[t] = r[t] && r[t].length % 2 == 0 ? r[t].concat(i[t]) : i[t];
      }

      return o;
    }(Ii, e) : Ii, j.call(this, [["getBrowser", (n = function n(i) {
      return i == g ? function () {
        return new Bi(i, r, s, a).set("ua", r).set(u, this.getBrowser()).set(h, this.getCPU()).set(p, this.getDevice()).set(m, this.getEngine()).set(f, this.getOS()).get();
      } : function () {
        return new Bi(i, r, s[i], a).parseUA().get();
      };
    })(u)], ["getCPU", n(h)], ["getDevice", n(p)], ["getEngine", n(m)], ["getOS", n(f)], ["getResult", n(g)], ["getUA", function () {
      return r;
    }], ["setUA", function (i) {
      return H(i) && (r = i.length > E ? Hi(i, E) : i), this;
    }]]).setUA(r), this) : new I(i, e, t).getResult();
  }

  I.VERSION = "2.0.3", I.BROWSER = U([v, y, L, k]), I.CPU = U([C]), I.DEVICE = U([T, x, k, G, S, e, r, t, D]), I.ENGINE = I.OS = U([v, y]), typeof exports !== n ? (exports = typeof module !== n && module.exports ? module.exports = I : exports).UAParser = I : typeof define === R && define.amd ? define(function () {
    return I;
  }) : Ti && (i.UAParser = I);
  var Ri,
      Vi = Ti && (i.jQuery || i.Zepto);
  Vi && !Vi.ua && (Ri = new I(), Vi.ua = Ri.getResult(), Vi.ua.get = function () {
    return Ri.getUA();
  }, Vi.ua.set = function (i) {
    Ri.setUA(i);
    var e,
        t = Ri.getResult();

    for (e in t) {
      Vi.ua[e] = t[e];
    }
  });
})("object" == typeof window ? window : this);